const CapitolStar = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.6804 6.88891L14.4431 3.1272L13.6582 2.3454L9.10926 5.32106L8 0H6.89074V6.18501C6.89074 6.57307 6.57624 6.88891 6.18665 6.88891H0V7.99788L5.32247 9.10826L1.55835 12.8728L2.34602 13.6546L6.89357 10.6789L8.00283 16H9.1121V9.81216C9.1121 9.4241 9.42802 9.10826 9.81619 9.10826H16V7.99788L10.6804 6.88891Z'
      fill='#1D76F3'
    />
  </svg>
);

export function WorkflowBuilderHeading() {
  return (
    <div className='flex flex-col items-start w-full max-w-3xl mb-8'>
      <div className='flex items-center gap-2 mb-1'>
        <CapitolStar />
        <span className='text-sm font-medium'>Welcome to Capitol</span>
      </div>
      <h1 className='text-3xl font-extralight tracking-tight'>
        I&apos;m ready to help you automate your workflows.
      </h1>
    </div>
  );
}
